import { render, staticRenderFns } from "./DescriptionSheetDetails.vue?vue&type=template&id=2b3aa6d0&scoped=true&"
import script from "./DescriptionSheetDetails.vue?vue&type=script&lang=js&"
export * from "./DescriptionSheetDetails.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionSheetDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DescriptionSheetDetails.vue?vue&type=style&index=1&id=2b3aa6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3aa6d0",
  null
  
)

export default component.exports